export interface AlarmsMarkerIconInterface {
  [name: string]: AlarmMarkerIconInterface;
}

export interface AlarmMarkerIconInterface {
  fontIcon: string;
  fontSet: string;
}
